import { combineReducers } from 'redux'
import { firestoreReducer } from 'redux-firestore'
import { firebaseReducer } from 'react-redux-firebase'
import updateUser from './userReducers/updateUserReducer'
import authReducer from './authReducers/authReducers'
import postReducer from './postReducers/postReducers'
import postCategories from './postReducers/postCategoryReducer';
import sendEnquiry from './userReducers/enquiryUserReducer';


 const rootReducer = combineReducers({
  updateInfo:updateUser,
  auth: authReducer,
  firestore: firestoreReducer,
  firebase: firebaseReducer,
  postReducer: postReducer,
  postCategories: postCategories,
  sendEnquiry: sendEnquiry
 })

export default rootReducer